import { render, staticRenderFns } from "./v-navbar-navigation-item.vue?vue&type=template&id=13e8c44c&scoped=true&"
import script from "./v-navbar-navigation-item.vue?vue&type=script&lang=js&"
export * from "./v-navbar-navigation-item.vue?vue&type=script&lang=js&"
import style0 from "./v-navbar-navigation-item.vue?vue&type=style&index=0&id=13e8c44c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13e8c44c",
  null
  
)

export default component.exports